import WarningLetterRequestContent from "../components/WarningLetterRequestContent";

const WarningLetterRequestPage = () => {
    return <WarningLetterRequestContent />;
};

export default WarningLetterRequestPage;
